import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import { GetReportListReq, GetReportListResp, Filter } from './types'

export const getReportListAction = createAsyncAction(
  'admin/report/sqd_project/GET_LIST_REQ',
  'admin/report/sqd_project/GET_LIST_RESP',
  'admin/report/sqd_project/GET_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()

export const updateFilter = createStandardAction(
  'admin/report/sqd_project/UPDATE_FILTER_ACTION'
)<Filter, void>()

export const clearFilter = createStandardAction(
  'admin/report/sqd_project/CLEAR_FILTER_ACTION'
)<void>()

export const sortingTask = createStandardAction(
  'admin/report/sqd_project/SORTING'
)<{
  name: string
  sort?: string
}>()

export const exportReportListAction = createAsyncAction(
  'admin/report/sqd_project/EXPORT_LIST_REQ',
  'admin/report/sqd_project/EXPORT_LIST_RESP',
  'admin/report/sqd_project/EXPORT_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()
